class Tools {
    isEmptyStr(input) {
        if (input === null || input === undefined || input === "") {
            return true
        }
        return false
    }
    interfacePropertyToString = (property: (object: any) => void) => {
        var chaine = property.toString();
        var arr = chaine.match(/[\s\S]*{[\s\S]*\.([^\.; ]*)[ ;\n]*}/);
        return arr[1];
    };
}
const tools = new Tools();
export default tools